import { platformBrowser } from '@angular/platform-browser';
import { defineCustomElements } from '@upr-gds-web/components/loader';
import { AppModule } from './app/app.module';

defineCustomElements(window);

platformBrowser()
  .bootstrapModule(AppModule, { ngZoneEventCoalescing: true })
  .catch((err) => console.log(err));
